module.exports = __webpack_public_path__ + "static/fonts/AvenirLTProBlack.a00f209.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/quiz-fonts/AvenirLTProBlack.ttf
// module id = 58mk
// module chunks = 1